/**
 * The Melio Payouts terms of service document a business accepts when it is created. `POST /v2/entities`
 * takes `termsAcceptance: { accepted, acceptedAt, version }` and rejects a `version` that is not the one
 * in force (PAYOUTS_TERMS_VERSION on the payouts side) — the document's last revision date. Bump this
 * whenever payouts bumps it.
 */
export const PAYOUTS_TERMS_VERSION = '2026-06-24';
